import { type RouteComponentProps } from '@gatsbyjs/reach-router'
import { navigate } from 'gatsby'
import { BigTitle, Column, PrimaryButton, rem, Row, SizedBox, Title } from '@collabhouse/shared'
import React, { type FunctionComponent } from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'

import CenteredPageTemplate from '../components/centered-page-template/CenteredPageTemplate'
import Page from '../components/page/Page'
import { routes } from '../utils/routes'

const Index: FunctionComponent<React.PropsWithChildren<RouteComponentProps>> = (props) => (
  <Page>
    <Helmet>
      <title>Not Found</title>
    </Helmet>
    <CenteredPageTemplate>
      <Page404Content {...props} />
    </CenteredPageTemplate>
  </Page>
)

export const Page404Content: FunctionComponent<React.PropsWithChildren<RouteComponentProps>> = ({ location }) => (
  <Column crossAxisAlignment="center">
    <Row crossAxisAlignment="baseline">
      <BigTitle size="xSmall">404</BigTitle>
      <SizedBox width={rem(24)} />
      <Title>Not Found</Title>
    </Row>
    <SizedBox height={rem(40)} />
    {location?.pathname && (
      <>
        <Row crossAxisAlignment="baseline">
          <Paragraph>
            Could not find page <strong>{location.pathname}</strong>.
          </Paragraph>
        </Row>
        <SizedBox height={rem(40)} />
      </>
    )}
    <PrimaryButton
      onClick={() => {
        void navigate(routes.home.url, { replace: true })
      }}
    >
      Take me home
    </PrimaryButton>
  </Column>
)

export default Index

const Paragraph = styled.p`
  text-align: center;
`
